import { render, staticRenderFns } from "./CreatorProfilePepal.vue?vue&type=template&id=f54a154e&scoped=true&"
import script from "./CreatorProfilePepal.vue?vue&type=script&lang=js&"
export * from "./CreatorProfilePepal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54a154e",
  null
  
)

export default component.exports